import { getJSONItem, setJSONItem } from './localStorage';
const storageKey = (customer, cabinetIdentifier) => "tru_".concat(customer, "_").concat(cabinetIdentifier, "_columns");

/**
 * Read the user's added column index keys for a cabinet from localStorage.
 * Returns an empty array if nothing is saved or the stored value is invalid.
 */
export const getAddedColumns = (customer, cabinetIdentifier) => {
  const stored = getJSONItem(storageKey(customer, cabinetIdentifier), {});
  const addedColumnIndexes = stored.addedColumnIndexes;
  if (!Array.isArray(addedColumnIndexes)) return [];
  return addedColumnIndexes.filter(v => typeof v === 'string');
};

/**
 * Persist the user's added column index keys for a cabinet to localStorage.
 */
export const setAddedColumns = (customer, cabinetIdentifier, indexes) => {
  setJSONItem(storageKey(customer, cabinetIdentifier), {
    addedColumnIndexes: indexes
  });
};